module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8601/img/InterstitialBlobs.png"